
import { useEffect } from "react";
import birminghamLogo from "@/assets/partners/birmingham.webp";
import lambethLogo from "@/assets/partners/lambeth.webp";
import lewishamLogo from "@/assets/partners/lewisham.webp";
import bromleyLogo from "@/assets/partners/bromley.webp";
import southwarkLogo from "@/assets/partners/southwark.webp";
import canterburyLogo from "@/assets/partners/canterbury.webp";
import tunbridgeWellsLogo from "@/assets/partners/tunbridge-wells.webp";
import bcpLogo from "@/assets/partners/bcp.webp";
import eastbourneLogo from "@/assets/partners/eastbourne.webp";
import swanseaLogo from "@/assets/partners/swansea.webp";
import mojLogo from "@/assets/partners/moj.webp";
import ocsLogo from "@/assets/partners/ocs.webp";

const PartnersSection = () => {
  const partners = [
    { name: "Birmingham City Council", logo: birminghamLogo, bgColor: "bg-[#882589]" },
    { name: "Lambeth Council", logo: lambethLogo, bgColor: "bg-[#333333]" },
    { name: "Lewisham Council", logo: lewishamLogo, bgColor: "bg-[#3E69A3]" },
    { name: "Bromley Council", logo: bromleyLogo, bgColor: "bg-white" },
    { name: "Southwark Council", logo: southwarkLogo, bgColor: "bg-[#02853B]" },
    { name: "Canterbury City Council", logo: canterburyLogo, bgColor: "bg-white" },
    { name: "Tunbridge Wells Borough Council", logo: tunbridgeWellsLogo, bgColor: "bg-white" },
    { name: "BCP Council", logo: bcpLogo, bgColor: "bg-white" },
    { name: "Eastbourne Borough Council", logo: eastbourneLogo, bgColor: "bg-[#08418A]" },
    { name: "Cyngor Abertawe Swansea Council", logo: swanseaLogo, bgColor: "bg-white" },
    { name: "Ministry of Justice", logo: mojLogo, bgColor: "bg-[#F9FBFD]" },
    { name: "OCS", logo: ocsLogo, bgColor: "bg-white" },
  ];

  useEffect(() => {
    partners.forEach(({ logo }) => {
      const img = new Image();
      img.src = logo;
    });
  }, []);

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="mb-4 text-center">
          <div className="mb-2 inline-block rounded-full bg-primary/15 px-4 py-1.5 text-sm font-medium text-primary border border-primary/20">
            Trusted Partners
          </div>
        </div>
        
        <h2 className="mb-4 text-center text-3xl font-bold text-foreground md:text-4xl">
          Working With Leading Organisations
        </h2>
        
        <p className="mb-12 text-center text-lg text-muted-foreground">
          From local councils to national governmental organisations.
        </p>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 max-w-3xl mx-auto">
          {partners.map((partner, index) => (
            <div
              key={index}
              className={`flex items-center justify-center rounded-2xl p-5 shadow-md transition-all duration-300 hover:shadow-xl hover:scale-105 h-28 ${partner.bgColor}`}
            >
              <img
                src={partner.logo}
                alt={`${partner.name} logo - PAMP Recruitment partner`}
                className="h-full w-auto max-w-full object-contain"
                width={180}
                height={80}
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
